
import axios from '../../functions/axios';
import { useReducer } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import  style from'./Car.module.css';

function EditCar(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const formReducer = (state, event) => {
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {
    _id: location.state?._id,
    plate: location.state?.plate,
  });

  const handleSubmit = async (event) => {
    if (event.target.id !== 'submit') return;
    event.preventDefault();
    event.stopPropagation();
    await axios.patch(`/car`, formData);
    navigate('/carsList');
  };

  const handleChange = (event) => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  };

  const handleDeleteCar = async (event) => {
    if (event.target.id !== 'remove') return;
    event.preventDefault();
    event.stopPropagation();
    const confirmBox = window.confirm("Czy chcesz usunąć te dane ?")
    if (confirmBox) {
      await axios.delete(`/car`, {
        data: {
          plate: location.state.plate,
        }
      });
    }
    navigate('/carsList');
  };

  return (
    <div className={style.wrapper}>
    <form>
      <div className={style.section}>
      <div className={style.category}>Edycja danych samochodu</div>
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='plate-data'>
            Nr rejestracyjny:
          </label>
          <input type="text" id='plate-data' placeholder="podaj nr rejestracyjny" name='plate' onChange={handleChange} value={location.state?.plate || ''} />
        </div>
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='brand-data'>
            Marka samochodu:
          </label>
          <input type="text" id='brand-data' placeholder="podaj marke samochodu" name='brand' onChange={handleChange} value={formData.brand ?? location.state?.brand ?? ''} />
        </div>
        <hr />
      <span className={style.buttons}>
        <button id="cancel" className='btn btn-default' onClick={navigate.bind(null, '/carsList', { state: { date: formData.day }})}>Anuluj</button>
        <button id="remove" className='btn btn-danger' onClick={handleDeleteCar}>Usuń</button>
        <button id="submit" className='btn btn-default' onClick={handleSubmit} type='submit'>Zapisz</button>
      </span>
      </div>
      </form>
    </div>
  );
}

export default EditCar;